import { useTheme } from "next-themes";
import { Toaster as Sonner, type ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      className="toaster group"
      style={
        // biome-ignore lint/plugin/no-type-assertion: existing type assertion; prefer type guards for new code
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
        } as React.CSSProperties
      }
      // biome-ignore lint/plugin/no-type-assertion: existing type assertion; prefer type guards for new code
      theme={theme as ToasterProps["theme"]}
      {...props}
    />
  );
};

export { Toaster };
